import { inject, provideAppInitializer } from '@angular/core';
import { of, switchMap, tap } from 'rxjs';
import { EnvironmentService } from '../environment.service';
import { BrandConfigService } from './brand-config.service';
import { StagDetectorService } from '../stag-detector.service';
import { CFCacheService } from '../cache-control.service';
import { UserService } from '../user/user.service';

export const provideBrandConfig = () => {
  return [
    provideAppInitializer(() => {
      const user = inject(UserService);
      const stag = inject(StagDetectorService);
      const cf = inject(CFCacheService);
      const env = inject(EnvironmentService);
      const brandConfig = inject(BrandConfigService);

      stag.detectParams();
      return user.getUserInfo().pipe(
        switchMap((e: any) => {
          // TODO temporary solution to prevent duplicate requests, needs to refactor user service & add state-managment
          if (!e?.id) {
            user.updateCurrentCurrencyBalance();
            return of(false);
          }
          return user.getPlayerStats().pipe(
            switchMap(() => user.getUserAccountsCompatibility()),
            switchMap(() => user.getUserAccounts())
          );
        }),
        switchMap(() => cf.loadCfCache()),
        switchMap(() => env.loadEnvironment()),
        tap(() => {
          brandConfig.brandConfigResolved.set(true);
          brandConfig.brandConfigResolved$.next(true);
        }),
      );
    }),
  ];
}
